import Highlight, { defaultProps } from 'prism-react-renderer';
import theme from 'prism-react-renderer/themes/nightOwl';
import React from 'react';
import styled from 'styled-components';

export const Pre = styled.pre`
  padding: 28px;
  line-height: 1.5;
  overflow-x: auto;
  text-align: left;

  @media only screen and (max-width: 1000px) {
    font-size: 14px;
    padding: 20px;
  }

  @media only screen and (min-width: 760px) and (max-width: 1000px) {
    .token-line {
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
  & .token-line {
    line-height: 1.5;
    /* line-height: 1.3em;
    height: 1.3em; */
  }
  /* font-family: 'Consolas'; */
`;

export const LineNo = styled.span`
  display: inline-block;
  width: 2em;
  user-select: none;
  opacity: 0.3;
`;

const Code = ({ codeString, language, ...props }) => {
  return (
    <Highlight
      {...defaultProps}
      code={codeString}
      language={language}
      theme={theme}
    >
      {({
        className,

        style,

        tokens,

        getLineProps,

        getTokenProps,
      }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <div {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>

              {line.map((token, key) => (
                <span {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </Pre>
      )}
    </Highlight>
  );
};

export default Code;
